var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-text"},[_c('editor',{ref:"Editor",attrs:{"disabled":_vm.isDisabled,"api-key":_vm.tinyApiKey,"init":{
      width: '100%',
      height: _vm.fieldHeight,
      menubar: false,
      elementpath: false,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
      ],
      toolbar:
        'undo redo | formatselect | bold italic backcolor | \
        alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat',
      block_formats: 'Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3; \
       Heading 4=h4; Heading 5=h5; Heading 6=h6;',
       advlist_bullet_styles: 'disc,circle,square',
       toolbar_mode: 'wrap'
    }},on:{"onBlur":_vm.setBlur,"onKeyDown":_vm.onKeyDown,"onKeyUp":_vm.setValue,"onChange":_vm.setValue,"onGetContent":function($event){return _vm.getContent($event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }